// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__27_su","tagline":"Hero_tagline__TjJIf","emojis":"Hero_emojis__Zj-Pt","plogin":"Hero_plogin__37aK4","phBadge":"Hero_phBadge__33wCk"};